import { render, staticRenderFns } from "./HelpCenterDefaultState.vue?vue&type=template&id=427c43a5&"
import script from "./HelpCenterDefaultState.vue?vue&type=script&lang=js&"
export * from "./HelpCenterDefaultState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports